export const build = { date:"2026-06-01.1614", stage:"alpha" }
